import localforage from "localforage";
import React from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";

import { auth } from "../../../../../shared/services/firebase";

export default function Logout() {
  useEffect(() => {
    async function handle() {
      try {
        await auth.signOut();
      } catch (e) {
        toast.error(
          "Erro ao tentar efetuar logout. Tente novamente mais tarde."
        );
      } finally {
        window.localStorage.clear();
        localforage.clear();
      }
    }

    handle();
  }, []);

  return <></>;
}
